import { Table } from 'antd'
import React from 'react'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Link } from 'react-router-dom';
import { encrypt } from '../../../../../Utils/CryptoHelper';
import { AuthData } from '../../../../../Components/Global';
dayjs.extend(utc);

const TableCOA = ({ dataSource }) => {

  const Auth = AuthData()

  const columns = [
    {
      key: 'COACode',
      title: 'COA Code',
      dataIndex: 'COACode',
      render: (value, record) => <Link to={`/dashboard/menuorder/coa/${encodeURIComponent(encrypt(Auth?.AccountId))}/${encodeURIComponent(encrypt(value))}`} className="text-second hover:text-second-200 font-medium">{value}</Link>
    },
    {
      key: 'ReportNumber',
      title: 'Report Number',
      dataIndex: 'ReportNumber',
    },
    {
      key: 'Status',
      title: 'Status',
      dataIndex: 'Status',
    },
    {
      key: 'PublishDate',
      title: 'Publish Date',
      dataIndex: 'PublishDate',
      render: (value) => dayjs.utc(value).format('YYYY-MM-DD')
    },
  ];

  return (
    <div>
      <h1 className="border-b-2 pb-1 text-xl mb-2">COA</h1>
      <Table
        bordered
        columns={columns}
        dataSource={dataSource}
        scroll={{
          x: 'max-content',
        }}
      />
    </div>
  )
}

export default TableCOA